import { Address } from '@ton/core';

const DEFAULT_ADDRESS_START_CHARS = 2;
const DEFAULT_ADDRESS_END_CHARS = -2;

export const getReadableAddress = (
  rawAddress: string,
  addressStartChars: number = DEFAULT_ADDRESS_START_CHARS,
  addressEndChars: number = DEFAULT_ADDRESS_END_CHARS,
) => {
  try {
    const address = Address.parse(rawAddress);
    const userFriendly = address.toString({
      urlSafe: true,
      bounceable: false,
    });

    return `${userFriendly.slice(0, addressStartChars)}...${userFriendly.slice(addressEndChars)}`;
  } catch {
    return `${rawAddress.slice(0, addressStartChars)}...${rawAddress.slice(addressEndChars)}`;
  }
};
